import { useState } from "react";
import { postDataAPI } from "../../utils/fetchData";
import { useNavigate } from "react-router";
import LayoutHeader from "../../layout/LayoutHeader";
import axios from "axios";
import { BASE_URL } from "../../utils/axios";
import usageTracker from "../../utils/usageTracker";
import Modal from "../../components/Modal";
import { useModal } from "../../hooks/useModal";

const ManualAdd = () => {
    const [editData, setEditData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const token = localStorage.getItem('dizeeToken');
    const navigate = useNavigate();
    const { modalConfig, showModal, closeModal } = useModal();

    const saveData = async () => {
        setIsLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem('dizeeToken'));
            const response = await axios.post(
                `${BASE_URL}/user/saveMerch`,
                { data: editData },
                { headers: { Authorization: token } }
            );
            
            if (response.data.status === 200) {
                showModal('Success', 'Merch item saved successfully!', 'success');
                
                // Track merch usage
                try {
                    await usageTracker.trackMerchItem(editData.product_type || 'general');
                } catch (trackingError) {
                    console.error('Usage tracking failed:', trackingError);
                }
                
                setTimeout(() => {
                    navigate('/merch/view-all');
                }, 1500);
            } else {
                console.log('Save response not successful:', response.data);
                showModal('Save Error', 'Error saving merch item. Please try again.', 'error');
            }
        } catch (error) {
            console.error('Error saving merch item:', error);
            showModal('Save Error', 'Error saving merch item. Please try again.', 'error');
        }
        setIsLoading(false);
    };

    const formFields = [
        // Product Info
        { key: 'product_id', label: 'Product ID', placeholder: 'Enter product ID' },
        { key: 'product_name', label: 'Product Name', placeholder: 'Enter product name' },
        { key: 'product_type', label: 'Product Type', placeholder: 'e.g., T-Shirt, Hoodie, Poster' },
        { key: 'vendor_brand', label: 'Vendor Brand', placeholder: 'Enter brand name' },
        { key: 'tags_collections', label: 'Tags/Collections', placeholder: 'Enter tags or collections' },
        { key: 'product_status', label: 'Product Status', placeholder: 'e.g., Active, Draft, Archived' },
        
        // Variants
        { key: 'variant_id', label: 'Variant ID', placeholder: 'Enter variant ID' },
        { key: 'variant_title', label: 'Variant Title', placeholder: 'Enter variant title' },
        { key: 'sku', label: 'SKU', placeholder: 'Enter SKU code' },
        { key: 'price', label: 'Price', placeholder: 'Enter price' },
        { key: 'compare_at_price', label: 'Compare At Price', placeholder: 'Enter compare price' },
        
        // Order Info
        { key: 'order_id', label: 'Order ID', placeholder: 'Enter order ID' },
        { key: 'order_name', label: 'Order Name', placeholder: 'Enter order name' },
        { key: 'order_date', label: 'Order Date', placeholder: 'Select order date', type: 'date' },
        { key: 'financial_status', label: 'Financial Status', placeholder: 'e.g., Paid, Pending, Refunded' },
        { key: 'fulfillment_status', label: 'Fulfillment Status', placeholder: 'e.g., Fulfilled, Pending, Shipped' },
        { key: 'total_price', label: 'Total Price', placeholder: 'Enter total price' },
        { key: 'subtotal', label: 'Subtotal', placeholder: 'Enter subtotal' },
        { key: 'discounts_applied', label: 'Discounts Applied', placeholder: 'Enter discounts' },
        { key: 'shipping_cost', label: 'Shipping Cost', placeholder: 'Enter shipping cost' },
        { key: 'taxes', label: 'Taxes', placeholder: 'Enter tax amount' },
        { key: 'currency', label: 'Currency', placeholder: 'e.g., USD, EUR, GBP' },
        { key: 'customer_name', label: 'Customer Name', placeholder: 'Enter customer name' },
        { key: 'customer_email', label: 'Customer Email', placeholder: 'Enter customer email' },
        { key: 'shipping_address', label: 'Shipping Address', placeholder: 'Enter shipping address', type: 'textarea' },
        
        // Financials
        { key: 'gross_sales', label: 'Gross Sales', placeholder: 'Enter gross sales' },
        { key: 'net_sales', label: 'Net Sales', placeholder: 'Enter net sales' },
        { key: 'refunds', label: 'Refunds', placeholder: 'Enter refund amount' },
        { key: 'net_revenue', label: 'Net Revenue', placeholder: 'Enter net revenue' },
        { key: 'payout_date', label: 'Payout Date', placeholder: 'Select payout date', type: 'date' },
        
        // Analytics
        { key: 'units_sold', label: 'Units Sold', placeholder: 'Enter units sold' },
        { key: 'conversion_rate', label: 'Conversion Rate', placeholder: 'Enter conversion rate %' }
    ];

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
                    {/* Header */}
                    <div className="px-4 my-[50px] flex w-full justify-between items-center">
                        <span className="text-white text-[14px]" style={{ fontWeight: 300 }}>Manual Add</span>
                        <div className="flex items-center gap-4">
                            {/* Navigation Buttons */}
                            <span 
                                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                onClick={() => navigate('/merch/view-all')}
                            >
                                View
                            </span>
                            
                            <span 
                                className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
                                onClick={() => navigate('/merch/bulk-import')}
                            >
                                Import
                            </span>
                            
                            <span className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" onClick={() => navigate(-1)}>Go back</span>
                        </div>
                    </div>

                    <div className="w-full px-4 flex-1 overflow-y-auto">
                        <div className="flex flex-col">
                            <div className="mb-6">
                                <span className="text-[14px] text-white" style={{ fontWeight: 300 }}>Add new merch item</span>
                                <p className="text-[10px] text-[rgba(255,255,255,0.7)] mt-1">Fill in the information for your new merchandise item</p>
            </div>

                            {/* Form Fields */}
                            <div className="space-y-4 mb-6">
                                {formFields.map((field) => (
                                    <div 
                                        key={field.key}
                                        className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#9932CC] hover:bg-[rgba(153,50,204,0.05)] transition-all"
                                    >
                                        <label className="block text-white text-[12px] mb-2" style={{ fontWeight: 300 }}>
                                            {field.label}
                                        </label>
                                        {field.type === 'textarea' ? (
                                            <textarea
                                                value={editData[field.key] || ''}
                                                onChange={(e) => setEditData({
                                                    ...editData,
                                                    [field.key]: e.target.value
                                                })}
                                                placeholder={field.placeholder}
                                                className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)] resize-none h-20"
                                            />
                                        ) : (
                                            <input
                                                type={field.type || 'text'}
                                                value={editData[field.key] || ''}
                                                onChange={(e) => setEditData({
                                                    ...editData,
                                                    [field.key]: e.target.value
                                                })}
                                                placeholder={field.placeholder}
                                                className="w-full bg-transparent border-none outline-none text-white text-[12px] placeholder-[rgba(255,255,255,0.5)]"
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Save Button */}
                            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[#9932CC] hover:bg-[rgba(153,50,204,0.05)] transition-all">
                                <button
                                    onClick={saveData}
                                    disabled={isLoading}
                                    className="w-full bg-[#9932CC] text-white text-[12px] font-semibold py-3 rounded-lg hover:bg-[rgba(153,50,204,0.9)] transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                >
                                    {isLoading ? (
                                        <>
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                            Saving...
                                        </>
                                    ) : (
                                        'Save Merch Item'
                                    )}
                                </button>
                </div>
            </div>

                        {/* Help Text */}
                        <div className="mt-6 mb-4">
                            <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                                <p>Fill in as much information as you have available for your merchandise.</p>
                                <p>You can always edit these details later from the merch list.</p>
                </div>
            </div>
                    </div>
                </div>
            </div>
            
            <Modal
                isOpen={modalConfig.isOpen}
                onClose={closeModal}
                onConfirm={modalConfig.onConfirm}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
                showCancel={modalConfig.showCancel}
                confirmText={modalConfig.confirmText}
                cancelText={modalConfig.cancelText}
            />
        </LayoutHeader>
    );
};

export default ManualAdd;